export default __webpack_public_path__ + "static/media/louis.91042ad2.png";